"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HammerSmashAbilityHandler = exports.HammerSmashActorAbilityFactory = exports.HammerSmashAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class HammerSmashAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HammerSmash;
        this.__typeName = "HammerSmash";
    }
}
exports.HammerSmashAbilityArgs = HammerSmashAbilityArgs;
let HammerSmashActorAbilityFactory = class HammerSmashActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HammerSmash", "OneEnemies", 0);
    }
};
HammerSmashActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HammerSmash")
], HammerSmashActorAbilityFactory);
exports.HammerSmashActorAbilityFactory = HammerSmashActorAbilityFactory;
let HammerSmashAbilityHandler = class HammerSmashAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 50)
            ]
        });
    }
};
HammerSmashAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HammerSmash)
], HammerSmashAbilityHandler);
exports.HammerSmashAbilityHandler = HammerSmashAbilityHandler;
